export enum STATSIG_FEATURE_GATES {
  // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/gates/rovo-ext_announcement_banner_enabled
  // FG for toggling announcement banner. Please don't remove it.
  ANNOUNCEMENT_BANNER_ENABLED = "rovo-ext_announcement_banner_enabled",
  // https://switcheroo.atlassian.com/ui/gates/558015fa-530c-4edd-9680-73da3160e8bf/key/rovo-ext_bannerman_enabled
  // FG for toggling Bannerman dynamic banner system. Please don't remove it.
  BANNERMAN_ENABLED = "rovo-ext_bannerman_enabled",
  // https://switcheroo.atlassian.com/ui/gates/cdebb45e-466d-4e00-8dc8-c8b914ba27f3/key/rovo-ext_ntp_calendar_widget_enabled
  NTP_CALENDAR_WIDGET_ENABLED = "rovo-ext_ntp_calendar_widget_enabled",
  // https://switcheroo.atlassian.com/ui/gates/43c7705c-5d94-4fbd-99cb-cc02861da827/key/rovo-ext-feature-gate-by-extension-version
  FEATURE_GATE_BY_EXTENSION_VERSION = "rovo-ext-feature-gate-by-extension-version",
  // https://switcheroo.atlassian.com/ui/gates/ff6bc152-83cf-429c-bd05-1df4a24d8d5f/key/hide_rovo_extension_ntp_welcome_header
  SHOW_ROVO_EXTENSION_NTP_WELCOME_HEADER = "hide_rovo_extension_ntp_welcome_header",
  // https://switcheroo.atlassian.com/ui/gates/d10cc0f3-f68b-436b-93d5-7f40ecfcd670/key/rovo_extension_safe_post_window
  SAFE_POST_WINDOW = "rovo_extension_safe_post_window",
  // https://switcheroo.atlassian.com/ui/gates/7d3cc87f-78fe-4ed1-a528-69b2f6eb937f/key/platform-dst-shape-theme-default
  PLATFORM_DST_SHAPE_THEME_DEFAULT = "platform-dst-shape-theme-default",
  //https://switcheroo.atlassian.com/ui/gates/7c652b22-efe3-4db0-a485-cc9d6e988569/key/navx_uc_rovo_extension_platform_creation_enabled
  /**
   * Controls cross-app creation for team/goal/project
   * Not intended to release for all. Internal testing within NavX Team
   */
  NAVX_PLATFORM_CREATION_ENABLED = "navx_uc_rovo_extension_platform_creation_enabled",
  // https://switcheroo.atlassian.com/ui/gates/8b4bfbc9-5a3f-4e75-a159-4831aba1e35a/key/rovo-ext_settings_admin_dom_context_toggle
  // Controls visibility of the admin DOM content access toggle and whether the admin setting
  // can override DOM context behavior when rovo_extension_dom_context_improvement is enabled.
  SETTINGS_ADMIN_DOM_CONTEXT_TOGGLE = "rovo-ext_settings_admin_dom_context_toggle",
  // https://switcheroo.atlassian.com/ui/gates/rovo-entitlement-api-guard
  // Guards API calls from being made when rovo LLM entitlement is disabled
  ENTITLEMENT_API_GUARD = "rovo-entitlement-api-guard",
  // SBS (Side-by-Side) evaluation gates
  /** Master on/off gate for the SBS evaluation system. */
  SBS_ENABLED = "rovo-ext_sbs_enabled",
  /** Whether this user has ChatGPT Enterprise access and is eligible for ChatGPT SBS pairings. */
  SBS_CHATGPT_ELIGIBLE = "rovo-ext_sbs_chatgpt_eligible",
  // https://switcheroo.atlassian.com/ui/gates/457e7f19-4339-40d9-aaed-e165657788a1/key/rovo-ext_custom-ntp-logo-custom-behavior
  NTP_LOGO_CUSTOM_BEHAVIOR = "rovo-ext_custom-ntp-logo-custom-behavior",
  // https://switcheroo.atlassian.com/ui/gates/aa878173-3ca2-47e1-b18c-0cc707b269b7/key/rovo-extension-session-replay-gate
  // Feature gate replacing the rovo-extension-session-replay experiment for controlling session replay.
  SESSION_REPLAY = "rovo-extension-session-replay-gate",
}
export enum STATSIG_DYNAMIC_CONFIGS {
  // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/dynamic_configs/rovo-ext_debug_menu_config
  DEBUG_MENU_CONFIG = "rovo-ext_debug_menu_config",
  // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/dynamic_configs/rovo_extension_demo_search_config
  DEMO_SEARCH_CONFIG = "rovo_extension_demo_search_config",
}
